import PopUpModal from "./popUpModal";

export default PopUpModal;
